import { mutatorAction } from 'satcheljs';
export default mutatorAction('updateUserConfettiOption', function (userOptions, confettiEnabled) {
    userOptions.confettiEnabled = confettiEnabled;
});
//# sourceMappingURL=updateUserConfettiOption.js.map